<header class="modal-header px-4 bg-white border-bottom-0">
  <h5 class="modal-title" id="modal-basic-title font-weight-bold">
    Cancelar establecimiento
  </h5>
  <button type="button" class="close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body">
  <div class="p-2">
    <form [formGroup]="formAsignarCancelacion">
      <div class="form-group mb-4">
        <h1 class="h6">
          Seleccione el tipo de cancelación para el establecimiento
        </h1>
      </div>
      <ul class="list-group">
        <div class="form-group" *ngFor="let item of estadosRNT; let i = index">
          <li class="list-group-item pointer" (click)="selecionarDato(item)">
            <img
              src="../../../../../../../../assets/icons/checked_2.png"
              alt=""
              height="18"
              *ngIf="
                formAsignarCancelacion.value.tipo_cancelacion_id !==
                item.estado_rnt_id
              "
            />
            <img
              src="../../../../../../../../assets/icons/checked.png"
              alt=""
              height="18"
              *ngIf="
                formAsignarCancelacion.value.tipo_cancelacion_id ===
                item.estado_rnt_id
              "
            />
            <label
              for="{{ item.descripcion }}"
              class="ml-4 form-check-label pointer"
              >{{ item.descripcion }}</label
            >
            <input
              id="{{ item.descripcion }}"
              class="form-check"
              type="checkbox"
              [hidden]="true"
            />
          </li>
        </div>
      </ul>
    </form>
    <footer class="text-right mt-4">
      <button
        class="btn btn-outline-primary modal-tipo-rnt-btn-inicio-outline mr-3 border-0"
        (click)="dismiss()"
      >
        Cancelar
      </button>
      <button
        class="btn btn-primary m-auto"
        [disabled]="!formAsignarCancelacion.valid"
        (click)="sendForm()"
      >
        Aceptar
      </button>
    </footer>
  </div>
</section>
